import { render } from "./TestimonialHS.vue?vue&type=template&id=9fa901c4&scoped=true"
import script from "./TestimonialHS.vue?vue&type=script&lang=js"
export * from "./TestimonialHS.vue?vue&type=script&lang=js"

import "./TestimonialHS.vue?vue&type=style&index=0&id=9fa901c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fa901c4"]])

export default __exports__